import { render } from "./SuccessMessage.vue?vue&type=template&id=3658fd37"
import script from "./SuccessMessage.vue?vue&type=script&lang=js"
export * from "./SuccessMessage.vue?vue&type=script&lang=js"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__